import { RemoveComma, showDateOnly } from "../../Common/Utility";

const columnsBuilder = () => {
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      type: "number",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value && params.value !== 0) return "";
        return RemoveComma(params.value);
      },
      renderCell: (params) => {
        if (!params?.value && params.value !== 0) return "";
        return RemoveComma(params.value);
      },
    },
    {
      field: "logType",
      headerName: "Type",
      width: 70,
      type: "string",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 80,
      type: "text",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return RemoveComma(params.value);
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return RemoveComma(params.value);
      },
    },
    {
      field: "statusText",
      headerName: "S.Text",
      width: 110,
      type: "text",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
    },
    {
      field: "message",
      headerName: "Message",
      flex: 1,
      type: "text",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      type: "text",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
    },
    {
      field: "guid",
      headerName: "GUID",
      width: 150,
      type: "text",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return params.value;
      },
    },
    {
      field: "userDate",
      headerName: "Datum",
      width: 160,
      type: "datetime",
      editable: false,
      valueFormatter: (params) => {
        if (!params?.value) return "";
        return showDateOnly(params.value);
      },
      renderCell: (params) => {
        if (!params?.value) return "";
        return showDateOnly(params.value);
      },
    },
  ];

  return columns;
};

export default columnsBuilder;
